import React from "react";
import { PromangRichTextEditor } from "../../utils/PromangRichTextEditor";

/**
 * Rich HTML editor for AI-created Outlook reply drafts.
 * @see {@link PromangRichTextEditor}
 */
export function MailReplyDraftRichEditor(props) {
  return <PromangRichTextEditor {...props} size="lg" framed={false} />;
}
